import React, { useState, useEffect } from "react";
import "./ExamScheduleResource.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

const ExamScheduleResource = () => {
  const [activeTab, setActiveTab] = useState("Autonomy");
  const [filters, setFilters] = useState({
    semester: null,
    examType: null,
    monthYear: null,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 5; // how many rows per page

const allData = {
  Autonomy: [
    {
      id: 1,
      name: "Sem 3 CA1-CA2 Notice",
      semester: "Sem III",
      examType: "CA1-CA2",
      monthYear: "",
      pdf: "/pdf/exam/Sem 3 CA1-CA2 Notice.pdf",
    }
  ],
  University: []
};

  const filteredData = allData[activeTab].filter((item) => {
    const matchesSearch = item.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesSemester = !filters.semester || item.semester === filters.semester;
    const matchesExamType = !filters.examType || item.examType === filters.examType;
    const matchesMonthYear =
      !filters.monthYear || item.monthYear === filters.monthYear;
    return matchesSearch && matchesSemester && matchesExamType && matchesMonthYear;
  });

  // reset to page 1 whenever filters/search/tab change
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab, filters, searchTerm]);

  const totalPages = Math.max(1, Math.ceil(filteredData.length / itemsPerPage));

  const currentData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleViewPDF = (pdfUrl) => {
    window.open(pdfUrl, "_blank");
  };

  const handleQuickFilter = (filterType, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: prev[filterType] === value ? null : value,
    }));
  };

  const clearFilters = () => {
    setFilters({ semester: null, examType: null, monthYear: null });
    setSearchTerm("");
  };

  return (
    <>
      <Navbar />
            <PageHeader
                 title="Exam Schedule"
                 crumbs={[
                   { label: "Home", href: "/" },
                   { label: "Exam Schedule" },
                 ]}
               />
      <div className="exam-esrc-page-root">
        <div className="exam-esrc-container">
               
       

          <div className="exam-esrc-inner">
            {/* Header */}

            {/* Toggle buttons */}
            <div className="exam-esrc-toggle-row">
              <button
                className={
                  activeTab === "Autonomy"
                    ? "exam-esrc-toggle-btn-active"
                    : "exam-esrc-toggle-btn"
                }
                onClick={() => {
                  setActiveTab("Autonomy");
                  clearFilters();
                }}
              >
                Autonomy
              </button>
              <button
                className={
                  activeTab === "University"
                    ? "exam-esrc-toggle-btn-active"
                    : "exam-esrc-toggle-btn"
                }
                onClick={() => {
                  setActiveTab("University");
                  clearFilters();
                }}
              >
                University
              </button>
            </div>

            {/* Quick filters */}
            <div className="exam-esrc-quick-filter-row">
              <span className="exam-esrc-quick-filter-label">Quick Filters</span>
              {/* <button
                className={
                  filters.semester === "Sem II"
                    ? "exam-esrc-quick-chip-primary"
                    : "exam-esrc-quick-chip"
                }
                onClick={() => handleQuickFilter("semester", "Sem II")}
              >
                Sem II
              </button> */}
              <button
                className={
                  filters.examType === "Practical"
                    ? "exam-esrc-quick-chip-primary"
                    : "exam-esrc-quick-chip"
                }
                onClick={() => handleQuickFilter("examType", "Practical")}
              >
                Practical
              </button>
              <button
                className={
                  filters.examType === "Theory"
                    ? "exam-esrc-quick-chip-primary"
                    : "exam-esrc-quick-chip"
                }
                onClick={() => handleQuickFilter("examType", "Theory")}
              >
                Theory
              </button>
              <button
                className={
                  filters.monthYear === "June 2026"
                    ? "exam-esrc-quick-chip-primary"
                    : "exam-esrc-quick-chip"
                }
                onClick={() => handleQuickFilter("monthYear", "June 2026")}
              >
                June 2026
              </button>
              {(filters.semester || filters.examType || filters.monthYear) && (
                <button
                  className="exam-esrc-quick-chip"
                  onClick={clearFilters}
                  style={{
                    backgroundColor: "#fee2e2",
                    color: "#991b1b",
                    borderColor: "#fecaca",
                  }}
                >
                  Clear All
                </button>
              )}
            </div>

            {/* Table */}
            <div className="exam-esrc-table-wrapper">
              <table className="exam-esrc-table">
                <thead>
                  <tr className="exam-esrc-thead-row">
                    <th className="exam-esrc-th">Document Name</th>
                    <th className="exam-esrc-th">Semester</th>
                    <th className="exam-esrc-th">Exam Type</th>
                    <th className="exam-esrc-th">Month/Year</th>
                    <th className="exam-esrc-th exam-esrc-text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item) => (
                      <tr key={item.id} className="exam-esrc-row">
                        <td className="exam-esrc-td">
                          <div className="exam-esrc-doc-cell">
                            <span className="exam-esrc-icon-wrapper">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="exam-esrc-svg-icon"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm0 2l4 4h-4V4zM8 14h8v2H8v-2zm0-4h5v2H8v-2z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            <span className="exam-esrc-doc-title">{item.name}</span>
                          </div>
                        </td>
                        <td className="exam-esrc-td">
                          <span className="exam-esrc-badge">{item.semester}</span>
                        </td>
                        <td className="exam-esrc-td">
                          <span className="exam-esrc-badge">{item.examType}</span>
                        </td>
                        <td className="exam-esrc-td exam-esrc-muted-text">
                          {item.monthYear}
                        </td>
                        <td className="exam-esrc-td exam-esrc-text-right">
                          <button
                            className="exam-esrc-view-btn"
                            onClick={() => handleViewPDF(item.pdf)}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="exam-esrc-td"
                        style={{ textAlign: "center", padding: "40px" }}
                      >
                        No results found. Try adjusting your filters.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination (only if more than 1 page) */}
            {currentData.length > 0 && totalPages > 1 && (
              <div className="exam-esrc-pagination">
                {Array.from({ length: totalPages }, (_, idx) => {
                  const page = idx + 1;
                  return (
                    <button
                      key={page}
                      className={
                        currentPage === page
                          ? "exam-esrc-page-btn-active"
                          : "exam-esrc-page-btn"
                      }
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                <span className="exam-esrc-pagination-dots">...</span>

                <button
                  className="exam-esrc-next-btn"
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  disabled={currentPage === totalPages}
                >
                  <span>Next</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="exam-esrc-svg-icon-small"
                    viewBox="0 0 24 24"
                  >
                    <path d="M10 17l5-5-5-5v10z" fill="currentColor" />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ExamScheduleResource;
